/* eslint-disable @typescript-eslint/no-explicit-any */
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import { DATE_FORMAT_2 } from 'Constant/Date';
import { LandingPageApis } from 'Datasource/LandingPage';
import { handleParseDate } from 'Utils/ParseDate';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';

// const data = [
//   {
//     id: 179030,
//     phoneNumber: '07669246xx',
//     codeJoin: 'Y1BOBC',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-03-27T01:06:17.000Z',
//   },
//   {
//     id: 189690,
//     phoneNumber: '09039932xx',
//     codeJoin: 'FFLD5R',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-04-18T09:09:17.000Z',
//   },
//   {
//     id: 148669,
//     phoneNumber: '07971095xx',
//     codeJoin: '848GLI',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-05-15T08:31:29.000Z',
//   },
//   {
//     id: 190444,
//     phoneNumber: '09070419xx',
//     codeJoin: 'Z5R53K',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-05-15T08:34:40.000Z',
//   },
//   {
//     id: 156091,
//     phoneNumber: '07875856xx',
//     codeJoin: '6NVESN',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-05-15T08:47:45.000Z',
//   },
//   {
//     id: 204832,
//     phoneNumber: '07777771xx',
//     codeJoin: 'S9LEW4',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-05-27T14:20:58.000Z',
//   },
//   {
//     id: 8102,
//     phoneNumber: '09358609xx',
//     codeJoin: '9S2H6H',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-06-13T09:30:51.000Z',
//   },
//   {
//     id: 57463,
//     phoneNumber: '09390688xx',
//     codeJoin: 'O8BQCA',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-06-13T09:30:20.000Z',
//   },
//   {
//     id: 205946,
//     phoneNumber: '07967201xx',
//     codeJoin: 'DTD1BP',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-06-13T09:46:36.000Z',
//   },
//   {
//     id: 208957,
//     phoneNumber: '09052058xx',
//     codeJoin: 'IIL6DB',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-06-27T19:05:02.000Z',
//   },
//   {
//     id: 208961,
//     phoneNumber: '09097774xx',
//     codeJoin: 'SJ8DND',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-06-27T23:41:00.000Z',
//   },
//   {
//     id: 208965,
//     phoneNumber: '09011519xx',
//     codeJoin: 'WXXSPF',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-06-28T07:05:55.000Z',
//   },
//   {
//     id: 209064,
//     phoneNumber: '09369687xx',
//     codeJoin: '196ZM9',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-07-10T02:31:58.000Z',
//   },
//   {
//     id: 214341,
//     phoneNumber: '07823395xx',
//     codeJoin: 'GEDZBP',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-07-17T07:00:22.000Z',
//   },
//   {
//     id: 214346,
//     phoneNumber: '09033279xx',
//     codeJoin: 'I5VM97',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-07-17T07:00:20.000Z',
//   },
//   {
//     id: 175466,
//     phoneNumber: '09058000xx',
//     codeJoin: 'R0G7JD',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-07-30T11:01:28.000Z',
//   },
//   {
//     id: 223727,
//     phoneNumber: '09063778xx',
//     codeJoin: '8HRJ6A',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-08-08T03:19:39.000Z',
//   },
//   {
//     id: 238149,
//     phoneNumber: '09072159xx',
//     codeJoin: 'A1JB9F',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-08-29T05:17:17.000Z',
//   },
//   {
//     id: 238152,
//     phoneNumber: '09370517xx',
//     codeJoin: '8MA24S',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-08-29T06:09:18.000Z',
//   },
//   {
//     id: 238162,
//     phoneNumber: '09315319xx',
//     codeJoin: 'OADCCU',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-08-29T07:13:33.000Z',
//   },
//   {
//     id: 251678,
//     phoneNumber: '09749169xx',
//     codeJoin: 'SIVCUH',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-09-11T08:21:56.000Z',
//   },
//   {
//     id: 103008,
//     phoneNumber: '09023058xx',
//     codeJoin: 'IHSQI6',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-09-11T08:37:30.000Z',
//   },
//   {
//     id: 252258,
//     phoneNumber: '07873348xx',
//     codeJoin: '0C7TF7',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-09-23T09:49:21.000Z',
//   },
//   {
//     id: 254251,
//     phoneNumber: '09344596xx',
//     codeJoin: 'S0DVXD',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-10-15T09:19:34.000Z',
//   },
//   {
//     id: 254333,
//     phoneNumber: '09057990xx',
//     codeJoin: '0P3VQB',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-10-15T09:27:26.000Z',
//   },
//   {
//     id: 118544,
//     phoneNumber: '09357253xx',
//     codeJoin: 'TZPTSV',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-10-31T09:02:04.000Z',
//   },
//   {
//     id: 25616,
//     phoneNumber: '09353334xx',
//     codeJoin: 'W85I8S',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-11-01T14:52:12.000Z',
//   },
//   {
//     id: 265036,
//     phoneNumber: '07944299xx',
//     codeJoin: '46M7NR',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-12-11T02:18:58.000Z',
//   },
//   {
//     id: 278148,
//     phoneNumber: '09049019xx',
//     codeJoin: 'XN8GVT',
//     prizeName: 'Đồng hồ thông minh Apple Watch Series 8 - GPS + Cellular, 41mm',
//     dateWin: '2026-12-15T01:09:34.000Z',
//   },
//   {
//     id: 278150,
//     phoneNumber: '09425724xx',
//     codeJoin: 'TSAXBL',
//     prizeName: 'Máy tính bảng iPad Gen 10 10.9 inch WiFi (64GB)',
//     dateWin: '2026-12-15T01:18:02.000Z',
//   },
// ];
export default function ResultTable(): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [userWin, setUserWin] = useState<any[]>([]);
  // {
  //   phone: '8473307614',
  //   codeJoin: 'ksfdgsgfweufs',
  //   prizeName: '33.990.000 VND',
  //   dateWin: '2023-05-12 04:28:30.294',
  //   dateReceive: '2023-05-12 04:28:30.294',
  // },

  const campaignId = process.env.REACT_APP_CAMPAIGN_ID as string;
  const handleGetUser = async () => {
    try {
      setLoading(true);
      const { data } = await LandingPageApis.getUserWin({ id: campaignId });
      if (data.length) {
        setUserWin(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleGetUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SpinnerComponent isLoading={loading} />
      <Table className="table-landing-page-result" responsive>
        <thead>
          <tr>
            <th>STT</th>
            <th>SỐ ĐIỆN THOẠI</th>
            <th>MÃ DỰ THƯỞNG</th>
            <th>GIẢI THƯỞNG</th>
            <th>NGÀY QUAY THƯỞNG</th>
            <th>NGÀY TRAO THƯỞNG</th>
          </tr>
        </thead>
        <tbody className="table-drag-item-body">
          {isEmpty(userWin) ? (
            <tr>
              <td className="text-center align-middle" colSpan={6}>
                Chưa có người trúng thưởng!
              </td>
            </tr>
          ) : (
            userWin.map((value, key) => {
              return (
                <tr key={`item-${key}`}>
                  <td>{key + 1}</td>
                  <td>{value.phoneNumber}</td>
                  <td>{value.codeJoin}</td>
                  <td>{value.prizeName}</td>
                  <td>
                    {handleParseDate({
                      date: value.dateWin,
                      format: DATE_FORMAT_2,
                    }) ?? '-'}
                  </td>
                  <td>
                    {' '}
                    {handleParseDate({
                      date: value.awardDate,
                      format: DATE_FORMAT_2,
                    }) ?? '-'}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </>
  );
}
